import React, { useState } from "react";
import { KeyRound, Loader2, ShieldOff } from "lucide-react";

/**
 * Disable 2FA — needs password AND a current 2FA code (or a recovery code).
 */
const DisableForm = ({ lang, submitting, onSubmit }) => {
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password || !code) return;
    const confirmed = window.confirm(
      lang === "fr"
        ? "Désactiver le 2FA ? Vos codes de secours seront supprimés."
        : "Disable 2FA? Your recovery codes will be cleared.",
    );
    if (!confirmed) return;
    onSubmit({ password, code: code.trim() }, () => {
      setPassword("");
      setCode("");
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6" data-testid="2fa-disable-form">
      <p className="text-sm text-[#A19E9C]">
        {lang === "fr"
          ? "Pour désactiver le 2FA, confirmez votre mot de passe et fournissez un code valide (6 chiffres) ou un code de secours."
          : "To disable 2FA, confirm your password and provide a valid 6-digit code or a recovery code."}
      </p>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="dis_pw" className="kw-label block mb-3">
            {lang === "fr" ? "Mot de passe" : "Password"} *
          </label>
          <input
            id="dis_pw"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="2fa-disable-password"
            className="kw-input"
          />
        </div>
        <div>
          <label htmlFor="dis_code" className="kw-label block mb-3">
            {lang === "fr" ? "Code 2FA ou code de secours" : "2FA or recovery code"} *
          </label>
          <input
            id="dis_code"
            type="text"
            inputMode="text"
            required
            value={code}
            onChange={(e) => setCode(e.target.value)}
            data-testid="2fa-disable-code"
            placeholder="123456 / xxxx-xxxx-xxxx"
            className="kw-input font-mono"
          />
        </div>
      </div>
      <div className="flex items-center gap-3">
        <KeyRound className="w-3.5 h-3.5 text-[#A19E9C]" strokeWidth={1.5} />
        <span className="text-[10px] uppercase tracking-[0.25em] text-[#A19E9C]">
          {lang === "fr"
            ? "Cette action efface vos codes de secours."
            : "This will clear your recovery codes."}
        </span>
      </div>
      <button
        type="submit"
        disabled={submitting || !password || !code}
        data-testid="2fa-disable-submit"
        className="kw-btn-primary disabled:opacity-40"
      >
        {submitting ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />
            {lang === "fr" ? "Désactivation…" : "Disabling…"}
          </>
        ) : (
          <>
            <ShieldOff className="w-4 h-4" strokeWidth={1.5} />
            {lang === "fr" ? "Désactiver" : "Disable"}
          </>
        )}
      </button>
    </form>
  );
};

export default DisableForm;
